module.exports = __webpack_public_path__ + "img/other_goal.54bd3329.png";